module.exports = __webpack_public_path__ + "static/media/eyeIcon.19326f7c.svg";